// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"4e2c2679","230":"773f92e7"}[chunkId] + ".chunk.js";
};